export function dialog_push(state = false, action) {
  if (action.type === 'SHOW_DIALOG_PUSH') {
    return true;
  }
  if (action.type === 'CLOSE_DIALOG_PUSH') {
    return false;
  }
  return state;
}
